<template>
    <!-- 详情信息 -->
    <slide-up-down :active="lineview" :duration="500">
        <div
            v-if="lineview"
            id="detail"
            class="detail"
            :style="{'width':cwrapWidth}">
            <p class="detail-title flex_xy_center">图像详情</p>
            <div class="board">
                <div class= "btnsle" id= "btnsle" :class="{ 'on': isSelected }" @click="clickSel(detail)"></div>
                <div v-if="detail.display_cover_pic_watermark" class="ip-img">
                    <div class="h39"></div>
                    <div class="ip-img-water">
                        <img alt="blank" src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" class="blankImg">
                        <img :data-src="detail.display_cover_pic_watermark ? _dealImageSuffix({value: detail.display_cover_pic_watermark, width: 520}) : ''" v-lazyLoad/>
                    </div>
                </div>
                <div class="cover-title">图形名称</div>
                <div class="cover-desc ql-editor" v-xss="detail.cover_pic_desc"></div>
                <p class="line"></p>
                <div class="ip">所属作品</div>
                <div class="ip-title">{{detail.ip_name}}</div>
                <div class="ip-author">作者：{{detail.author}}</div>
                <div class="ip-cover">
                    <img alt="blank" src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" class="blankImg">
                    <img :data-src="detail.display_cover_pic ? _dealImageSuffix({value: detail.display_cover_pic, width: 380}) : ''" v-lazyLoad/>
                </div>
                <div class="ip-desc ql-editor" v-xss="detail.ip_desc"></div>
                <p class="line"></p>
                <template v-if="detail.cut_case_pic_list">
                    <div class="cover-anli">案例展示</div>
                    <div class="cover-pics">
                        <img alt="blank" src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" class="blankImg">
                        <img 
                            v-for="(v, k) in detail.cut_case_pic_list" :key="'case_pic'+k"
                            :data-src="v ? _dealImageSuffix({value: v, width: 780}) : ''" 
                            v-lazyLoad
                        />
                    </div>
                </template>
                
            </div>
            <template v-if="detail.recommand && detail.recommand.length">
                <p class="detail-title">相关推荐</p>
                <div class="board">
                    <div class="recommands">
                        <div 
                            v-for="(v, k) in detail.recommand" :key="'recommand'+k"
                            class="board-recommand flex_layout flex_y_center"
                        >
                            <div class="ipimg flexitem_flexshrink_0 flex_xy_center">
                                <div class="iphead">
                                    <img alt="blank" src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" class="blankImg">
                                    <img :data-src="v.display_cover_pic ? _dealImageSuffix({value: v.display_cover_pic, width: 200}) : ''" v-lazyLoad/>
                                </div>
                            </div>
                            <div class="board-recommand-r">
                                <div class="board-recommand-r-title">{{v.cover_pic_name}}</div>
                                <div class="board-recommand-r-desc ql-editor" v-xss="v.cover_pic_desc"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </slide-up-down>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
    name:"detail",
    data () {
        return {
        };
    },
    props: {
        lineview: {
            type: Boolean,
            default: false,
        },
        cwrapWidth: {
            type: String,
            default: '',
        },
        detail: {
            type: Object,
            default: {},
        },
        list: {
            type: Array,
            default: [],
        },
    },
    computed: {
        ...mapState(["iplist"]),
        isSelected() {
            return this.iplist.has(this.detail.id);
        }
    },
    methods: {
        ...mapMutations(["setIpList"]),
        clickSel({id} = {}) {
            let iplist = new Map(this.iplist);
            this.list.forEach(item => {
                if (id === item.id) {
                    if (iplist.has(id)) {
                        iplist.delete(id);
                    } else {
                        iplist.set(id, item);
                    }
                }
            })
            localStorage.setItem('iplist', JSON.stringify(Array.from(iplist)));
            this.setIpList(iplist);
        },
    }
};
</script>

<style lang='scss'>
.ql-editor {
    img{
        width:auto;    
    }
}
.board-recommand-r-desc{
    p{
        word-break:break-all;
    }
}
</style>
<style lang='scss' scoped>
@import "@/css/common.scss";

.detail{
    margin:0 0 vws(20px) 0;
    width:vws(1184px);
    background:#FFE120;
    border-radius:vws(20px);
    padding:0 vws(12px) vws(12px);
    color: #1E1E1E;
    .detail-title{
        font-size:vws(36px);
        font-weight:bold;
        text-align:center;
        padding:vws(20px);
    }
    .board{
        position:relative;
        width:100%;
        background: #FFFFFF;
        border-radius: vws(20px);
        padding:0 0 vws(30px);
        .btnsle{
            position:absolute;
            right:vws(14px);
            top:vws(30px);
            width:vws(84px);
            height:vws(92px);
            background:url(../img/sle_off@2x.png) no-repeat;
            background-size:cover;
            z-index: 1;
        }
        .btnsle.on{
            background:url(../img/sle_on@2x.png) no-repeat;
            background-size:cover;
        }
        .ip-img{
            .h39{
                width:100%;
                height:vws(39px);
            }
            .ip-img-water{
                position:relative;
                width:vws(520px);
                height:vws(520px);
                margin:0 auto;
                border-radius:vws(20px);
            }
        }
        .cover-title{
            font-size:vws(30px);
            font-weight:bold;
            text-align:center;
            padding-top:vws(32px);
        }
        .cover-desc{
            font-size:vws(18px);
            padding: vws(27px) vws(220px) 0;
            margin:0 auto;
        }
        .line{
            width:vws(1012px);
            height: vws(2px);
            background: #E5E5E5;
            margin:vws(30px) auto 0;
        }
        .ip{
            font-size:vws(30px);
            font-weight:bold;
            text-align:center;
            padding-top:vws(34px);
        }
        .ip-title{
            font-size:vws(24px);
            font-weight:bold;
            text-align:center;
            padding-top:vws(22px);
        }
        .ip-author{
            font-size:vws(24px);
            font-weight:bold;
            text-align:center;
            padding-top:vws(10px);
        }
        .ip-cover{
            position:relative;
            width:vws(384px);
            margin:vws(19px) auto 0;
        }
        .ip-desc{
            margin:0 auto;
            font-size:vws(18px);
            padding: vws(26px) vws(140px) 0;
        }
        .cover-anli{
            margin:0 auto;
            font-size:vws(30px);
            font-weight:bold;
            text-align:center;
            padding-top:vws(33px);
        }
        .cover-pics{
            position:relative;
            width:vws(780px);
            margin:vws(22px) auto 0;
        }
        .recommands{
            padding:vws(40px) vws(68px);
            .board-recommand{
                margin-bottom:vws(40px);
                .ipimg{
                    width: vws(146px);
                    height: vws(146px);
                    border: vws(2px) solid #FFE120;
                    border-radius: vws(24px);
                    .iphead{
                        position:relative;
                        font-size:0;
                        width: vws(130px);
                        height: vws(130px);
                        background: #E5E5E5;
                        border-radius: vws(24px);
                        overflow:hidden;
                    }
                }
                .board-recommand-r{
                    padding-left:vws(30px);
                    .board-recommand-r-title{
                        font-size:vws(24px);
                        font-weight:bold;
                        padding-bottom:vws(10px);
                    }
                    .board-recommand-r-desc{
                        padding:0;
                        font-size:vws(18px);
                        word-wrap: break-word;
                        display:-webkit-box;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 4;
                        -webkit-box-orient: vertical;
                        p{
                            word-wrap:break-all;
                        }
                    }
                }
            }
        }
    }
}

@media (max-width:750px) {
    .detail{
        width:100%;
        .board{
            .btnsle{
                right:vws(6px);
                top:vws(15px);
                width:vws(64px);
                height:vws(70px);
            }
            .cover-desc{
                padding: vws(27px) vws(50px) 0;
            }
            .ip-desc{
                padding: vws(26px) vws(50px) 0;
            }
            .cover-pics{
                width:vws(500px);
            }
            .line{
                width:vws(600px);
            }
            .recommands{
                padding:vws(20px) vws(34px);
               .board-recommand{
                    margin-bottom:vws(20px);
                    .board-recommand-r{
                        .board-recommand-r-desc{
                            -webkit-line-clamp: 3;
                        }
                    }
                } 
            }
        }
    }
}
</style>


